$(function() {
    // Draggable

    if ($('#fullDraggable').length > 0) {
        var width = $(window).width();

        if (width <= 1280) {
            var headWidth = $('#fullDraggable .head').width();
            var colsWidth = $('#fullDraggable .col').width();
            var colsCount = $('#fullDraggable .col').length;

            $('#fullDraggable').draggable({
                axis: "x",
                scroll: true
            });

            $('#fullDraggable').css({
                'width': (colsCount * colsWidth) + (headWidth + colsCount) + 'px',
                'cursor': 'move'
            });
        }
    }
});